import React from 'react';
import { Pagination, Select } from 'antd';
import { pagination } from '../../../Tasks/configs/designTokens';

const PAGE_SIZES = pagination.pageSizes;

const TagsPagination = ({ current, pageSize, total, onChange, onPageSizeChange, compact, simple }) => {
  if (!total || total === 0) return null;

  const start = (current - 1) * pageSize + 1;
  const end = Math.min(current * pageSize, total);

  return (
    <div className={`tags-pagination ${compact ? 'tags-pagination--compact' : ''} ${simple ? 'tags-pagination--simple' : ''}`}>
      {!compact && !simple && (
        <div className="tags-pagination__left">
          <span className="tags-pagination__summary">
            Showing <strong>{start}</strong> - <strong>{end}</strong> of{' '}
            <strong>{total}</strong> tags
          </span>
        </div>
      )}

      <div className="tags-pagination__center">
        <Pagination
          current={current}
          pageSize={pageSize}
          total={total}
          showSizeChanger={false}
          hideOnSinglePage={false}
          onChange={(page) => onChange(page)}
          className="tags-pagination__nav"
        />
      </div>

      <div className="tags-pagination__right">
        {compact ? (
          <Select
            value={pageSize}
            onChange={onPageSizeChange}
            className="tags-pagination__size-select"
            size="small"
          >
            {PAGE_SIZES.map((size) => (
              <Select.Option key={size} value={size}>
                {size} / page
              </Select.Option>
            ))}
          </Select>
        ) : (
          <>
            <span className="tags-pagination__size-label">Show:</span>
            <div className="tags-pagination__size-options">
              {PAGE_SIZES.map((size) => (
                <button
                  key={size}
                  className={`tags-pagination__size-btn ${
                    pageSize === size ? 'tags-pagination__size-btn--active' : ''
                  }`}
                  onClick={() => onPageSizeChange(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TagsPagination;
